import {AcceptBag, AcceptBagCallback, AcceptBagContractModel} from "@next/eventservice"
import {ShoppingBagApiPost} from "../../api/shoppingbag"

const getBagESB = new AcceptBag()
const getBagCallbackESB = new AcceptBagCallback()

export const SubscribeToShoppingBagAccept = (siteUrl: string) => {
    getBagESB.subscribe(data => {
        LoadApiData(siteUrl, data)
    })
}

class BagAcceptApiModel {
    id = ""
}

const LoadApiData = (url: string, data: AcceptBagContractModel) => {
    const apiModel = new BagAcceptApiModel()
    apiModel.id = data.id

    ShoppingBagApiPost(apiModel, `${url}/bag/accept`, getBagCallbackESB, data.eventId)
}
